/**
 * BattleSettlementData 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { BattleRealtimeData } from './battle_realtime_data'

/**
 * BattleSettlementData
 */
export interface BattleSettlementData {
  /** 最终数据快照 */
  final_data?: BattleRealtimeData
  /** 胜负状态 */
  victory_state?: string
  /** 对战时长（秒） */
  duration?: number
  /** 结算时间戳 */
  settled_at?: number
}

/**
 * BattleSettlementData Schema
 */
export const BattleSettlementDataSchema: SchemaDefinition = {
  properties: {
    final_data: {
      $ref: 'BattleRealtimeData',
      description: '最终数据快照',
      label: '最终数据快照',
    },
    victory_state: {
      description: '胜负状态',
      format: 'cons.BattleVictoryState',
      type: 'string',
      label: '胜负状态',
    },
    duration: {
      description: '对战时长（秒）',
      format: 'int',
      type: 'integer',
      label: '对战时长',
    },
    settled_at: {
      description: '结算时间戳',
      format: 'int',
      type: 'integer',
      label: '结算时间戳',
    },
  },
  type: 'object',
}
